// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tt-avatar[data-v-6a2c9e8e] {\n  display: inline-block;\n  border-radius: 50%;\n  background-image: var(--image-user-icon);\n  background-position: 50% 50%;\n  background-clip: content-box;\n  background-size: cover;\n  background-repeat: no-repeat;\n  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.2);\n}\n", ""]);
// Exports
module.exports = exports;
